import React from 'react';  // import the React library
import '../App.css'; // import your CSS file
import { motion } from 'framer-motion';
import BioLine from '../articleComponents/bioLine.js'; // import your CSS file
import Connect from '../articleComponents/connect';
import SocialMedia from '../articleComponents/SocialMedia';
import MetaTags from '../mainPageComponents/MetaTags';
import planet from '../pictures/planet_img.jpg';
import TraversePosts from '../articleComponents/navigation';
import peakOfGivatHaMore from '../images/topOfMore.jpg';
import Image from '../mainPageComponents/image.js';

const today = new Date("11, 11, 2020").toLocaleDateString('en-US', {  
  day:   'numeric',
  month: 'short',
  year:  'numeric',
  weekday: 'long'
});

function HelloWorld() {
    return (
        <motion.div className="articleStyle"
        initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>

<MetaTags title="Let's Go for a Spin" desc="David Ben Horin is the developer for Highway 60. A marketer for 10 years, he decided to see what the other side of his profession is up to by coding this app." 
URL="https://highway-60.firebaseapp.com/articles/hello-world" imageURL={planet} />

        <h1>Let's Go for a Spin</h1>

        <Image picURL="https://i.imgur.com/SPrG2WA.jpg" />

<BioLine />
<p>{today}</p>


<div style={{textAlign: "left", marginTop: "5px", marginBottom: "20px"}}>
<SocialMedia url="https://highway-60.firebaseapp.com/articles/hello-world" title="Highway 60" hashtag="#highway60" hashtagArray={["marketing", "writing"]} via="TheHighway60" desc="Hello world from the great Highway 60!" />
</div>

    <p><i>What came first, the chicken or the egg? The egg, of course. Who eats chicken for breakfast?</i></p>

<p>
    “David, it took me 15 minutes to figure out how wrong you were.”
</p>

<p>
    That was the reply my boss gave me right after my first assignment. After working as a marketer in hi-tech, I took a job writing for a database.
</p>

<p>
    How hard could it be?
</p> 

<p>
    Little did I know that this was one of the most deep level pieces of software out there. In order to talk about it, you really had to know about programming.
</p>

<p>
    I thought I did. I coded a website with login authentication, isn’t that enough?
</p>

<p>
    Well, I found out soon enough when I decided to start trying my hand a C#. I programmed in my “Hello world” program and the computer just sat there.
</p>

<p>
    “Hey Iftah, why isn’t the computer rendering my Hello World?”
</p>

<p>
    “David, you’re not . . . you are!”
</p>

<p>
    He was biting his lip, trying hard not to laugh.
</p>

<p>
    “We don’t render C# on a notepad file. You need an IDE buddy. This isn’t 1996.”
</p>

<p>
    Well, for me it still is.
</p>

<p>
    I decided that as a marketer, if I want to get anywhere in high-tech, I’d better learn how to code.
</p>

<h1>
    Here is my site, 1996 is reborn. Hey Macarena!
</h1>

<iframe width="560" height="315" src="https://www.youtube.com/embed/zJ2hqQWIx64" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

<p>
    That’s the plan. The guys say in order to code, you have to code. They told me to stop taking too many courses and just dive right in.
</p>

<p>
    So here we go. The site looks like it was done right after I watched a live episode of 3rd Rock from the Sun.
</p>

<p>
    That’s the way I want it. Here is my ReactJS App, warts and all. I sneaked in a little CSS pizzaz for some spice, and maybe I tried a function here and there.
</p>

<p>
    Look at me go!
</p>

<p>
    The plan is to keep coding and slowly improve the quality of my site. As I learn something new, I will incorporate it into what you see and tell you all about it.
</p>

<p>
    As a marketer, my perspective on things is unique. I can talk about what I am experiencing for the first time with a new set of eyes.
</p>

<p>
    I hope you enjoy it.
</p>

<p>
    Now if you will excuse me, I sent my boss a copy of this site and it’s been 15 minutes.
</p>

<TraversePosts prevURL="../articles" nextURL="/articles/a-big-decision"/>

<Connect />
</motion.div>
  );
}

export default HelloWorld;
